export default __webpack_public_path__ + "static/media/Bass Pro Reel Rip.c683e85f.png";